import React, { Fragment, useState, useEffect } from "react";
import { ScaleLoader } from "react-spinners";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Routers from "../../routers/Routers";


const Layout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulating some asynchronous operation
    const fetchData = async () => {
      // You can add your data fetching logic here
      // For example, you might check user authentication or fetch initial data
      // Simulating a delay for demonstration purposes
      await new Promise((resolve) => setTimeout(resolve, 3000));

      // Set loading to false after the async operation is done
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <Fragment>
      {loading ? (
        // Render the preloader while loading
        <div className="preloader">
          <ScaleLoader color={"#ffffff"} loading={loading} />
        </div>
      ) : (
        // Render the main content when loading is false
        <div>
          <Header />
          <Routers />
          <Footer />
        </div>
      )}
    </Fragment>
  );
};

export default Layout;
